import type { ReactNode } from "react";

export interface ItemVendorProps {
  children: ReactNode;
}

export function ItemVendor({ children }: ItemVendorProps) {
  return (
    <h4 className="item--vendor" data-test-id="item-vendor">
      {children}
    </h4>
  );
}
